export default {
  'mrn:agent_condition:speed_limit': ['mrn:agent_condition:geofence_in'],
  'mrn:agent_condition:geofence_in': [],
  'mrn:agent_condition:panic_button': [],
  'mrn:agent_condition:lasso_disconnected': [],
  'mrn:agent_condition:driver_door': [],
  'mrn:agent_condition:cargo_gate': [],
  'mrn:agent_condition:semi_detach': [],
  'mrn:agent_condition:tamper_sensor': [],
  'mrn:agent_condition:geofence_out': [],
  'mrn:agent_condition:ignition_on': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:ignition_off': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:fuel_cut_off': [],
  'mrn:agent_condition:main_power_on': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:main_power_off': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:no_report': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all',
    'mrn:agent_condition:speed_limit'
  ],
  'mrn:agent_condition:detention': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all',
    'mrn:agent_condition:ignition_on',
    'mrn:agent_condition:ignition_off'
  ],
  'mrn:agent_condition:movement_start': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all',
    'mrn:agent_condition:ignition_off'
  ],
  'mrn:agent_condition:low_battery': [],
  'mrn:agent_condition:ralenti': ['mrn:agent_condition:geofence_outside_all'],
  'mrn:agent_condition:fuel_consumption_deviation': [
    // 'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:temperature': [],
  'mrn:agent_condition:fuel_charge': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:generic_unauthorized_stop': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:generic_put_into_service': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:generic_taken_out_of_service': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:generic_still_detached': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:generic_event_test': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:generic_event_test': ['mrn:agent_condition:geofence_in'],
  'mrn:agent_condition:generic_seat_passenger': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:generic_delivery': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:generic_sharped_turn': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:generic_hard_brake': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:generic_hard_acceleration': [
    'mrn:agent_condition:geofence_in',
    'mrn:agent_condition:geofence_outside_all'
  ],
  'mrn:agent_condition:engine_temperature': [],
  'mrn:agent_condition:excessive_rpm': [],
  'mrn:agent_condition:multi_temperature': []
}
